<template>
    <div v-if="show">
        <template v-if="session.success">
            <div class="alert alert--success px-4 py-2 rounded shadow">
                <div class="flex items-center justify-between">
                    <svg class="alert__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                    </svg>

                    <div class="alert__content">
                        <p class="font-bold">Uspeh!</p>
                        <p class="mt-0.5">{{ session.success }}</p>
                    </div>

                    <div class="pl-3 ml-auto">
                        <button type="button" class="alert__close" @click="show=false">
                            <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="session.error">
            <div class="alert alert--danger px-4 py-2 rounded shadow">
                <div class="flex items-center justify-between">
                    <svg class="alert__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" />
                    </svg>

                    <div class="alert__content">
                        <p class="font-bold">Napaka</p>
                        <p class="mt-0.5">{{ session.error }}</p>
                    </div>

                    <div class="pl-3 ml-auto">
                        <button type="button" class="alert__close" @click="show=false">
                            <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        session: Object,
    },
    data() {
        return {
            show: true,
        };
    }
}
</script>
